import { render } from "./SlotPageDetail.vue?vue&type=template&id=656aba76&scoped=true"
import script from "./SlotPageDetail.vue?vue&type=script&lang=js"
export * from "./SlotPageDetail.vue?vue&type=script&lang=js"

import "./SlotPageDetail.vue?vue&type=style&index=0&id=656aba76&lang=scss&scoped=true"

import exportComponent from "/Users/derem1991/workspace/newear/frontend/theearcasino/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-656aba76"]])

export default __exports__